import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import ContainerLayout from "../../../layouts/two-columns/container-layout";
import { retrievePageMenu } from "../../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../../redux/store";

import addSsoTokenQuery from "../../../helpers/add-sso-token.helper";
import useAuth from "../../../hooks/useAuth";
import { useDynamicScripts } from "../../../hooks/useDynamicScript";
import LoadingComp from "../../../components/re-usable/loading/loading";

const EnterpriseMembers = () => {
  const user = useAuth().getUser();
  const ssoToken = user ? user.ssoToken : null;

  const breadcrumbPath = "Membership%2FAcademic-Enterprise";
  const path = `%2F${breadcrumbPath}`;

  const dispatch = useAppDispatch();
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const [htmlString, setHtmlString] = useState("");
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    dispatch(retrievePageMenu(path));
  }, [dispatch]);

  useEffect(() => {
    if (RapsEuropeData[0]) {
      let rapsResult = RapsEuropeData[0].result && RapsEuropeData[0].result[0];

      if (rapsResult) {
        if (ssoToken) {
          let newDescription = addSsoTokenQuery(rapsResult.description, user.ssoToken);

          setHtmlString(newDescription);
        } else {
          setHtmlString(rapsResult.description);
        }

        if (rapsResult.javaScriptField) {
          setScriptHtmlString(RapsEuropeData[0].result[0].javaScriptField);
        }
      }
    }
  }, [RapsEuropeData]);

  useDynamicScripts({ htmlScriptString: scriptHtmlString });

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0].menuItemName}</title>
      </Helmet>
      <ContainerLayout breadcrumbPath={breadcrumbPath} isBreadcrumbPath={true} showAds={true}>
        <div dangerouslySetInnerHTML={{ __html: htmlString }}></div>
      </ContainerLayout>
    </>
  );
};

export default EnterpriseMembers;